export const commonRedditCallsMixin  = {
    methods: {
        getBotPermissions(subreddit) {
            let response = {
                'all': false,
                'wiki': false,
                'post': false
            }
            console.log(response)
            return this.$redditApi.get(`https://oauth.reddit.com/r/${subreddit}/about/moderators`)
                .then(res => {
                    let sleuthModData = res.data.data.children.find(i => i.name === 'RepostSleuthBot');
                    if (sleuthModData === null) {
                        return response;
                    }
                    response.all = sleuthModData.mod_permissions.includes('all')
                    response.wiki = sleuthModData.mod_permissions.includes('wiki')
                    response.all = sleuthModData.mod_permissions.includes('wiki')
                    return response;
                })
        },

        loadSubreddits(after = '', subreddits = []) {
            let url = `https://oauth.reddit.com/subreddits/mine/moderator?after=${after}`;
            return this.$redditApi.get(url)
                .then(res => {
                    console.log(res)
                    if (res.data.data.children.length === 0) {
                        return subreddits;
                    }
                    res.data.data.children.forEach(sub => {
                        const subData = {
                            redditData: {
                                name: sub.data.display_name,
                                image: sub.data.icon_img ? sub.data.icon_img : require('../../assets/images/reddit_logo.png'),
                                active: true
                            },
                            repostSleuthData: null,
                        }
                        if (sub.data.banner_background_image !== null) {
                            subData.redditData.banner_image = sub.data.banner_background_image.split('?')[0]
                        }
                        subreddits.push(subData)

                    })
                    if (res.data.data.after) {
                        return this.loadSubreddits(res.data.data.after, subreddits);
                    }
                    return subreddits;
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        addModerator(subreddit, user) {
            console.log(`Sending mod invite to ${subreddit}`)
            var bodyFormData = new FormData()
            bodyFormData.append('api_type', 'json')
            bodyFormData.append('name', user)
            bodyFormData.append('type', 'moderator_invite')
            bodyFormData.append('permissions', '+posts,+wiki')
            return this.$redditApi.post(`https://oauth.reddit.com/r/${subreddit}/api/friend`, bodyFormData, {headers: {'Content-Type': 'multipart/form-data'}})
                .then(res => {
                    return res.data.json.errors;
                })
        },
        getSubreddit(subreddit) {
            return this.$redditApi.get(`https://oauth.reddit.com/r/${subreddit}/about`)
                .then(res => {
                    return res.data.data;
                })
        }
    },

}
